import i18n from 'services/base/i18n';

export default {
  // A placeholder "device" on the parental controls device list that represents all devices
  allDevices: () => i18n.pgettext('Components|Parental Controls|Devices', 'All Devices'),
};
